'use client';
import ProductDefault from '../product/ProductDefault';
import ProductDefaultMobile from '../product/ProductDefaultMobile';
import { useSearchParams } from 'next/navigation';
import { useIsMobile } from '@/app/_hooks/useIsMobile';

export default function ArchiveContent({ products, priorityProducts = [] }) {
  const searchParams = useSearchParams();
  const isPageOne = !searchParams.get('page') || searchParams.get('page') == 1;
  const hasPriorityProducts = isPageOne && priorityProducts.length > 0;
  const isMobile = useIsMobile();
  return (
    <div className="category-product-list flex flex-wrap rounded-lg border border-light-gray-300  ">
      {hasPriorityProducts &&
        searchParams?.size === 0 &&
        priorityProducts.map((product, index) => (
          <div
            key={product.id}
            className="overflow-hidden w-full sm:1/2  lg:w-1/4 xl:w-1/4 border-light-gray-300 md:border-l border-b"
          >
            {!isMobile ? (
              <ProductDefault product={product} index={index} />
            ) : (
              <ProductDefaultMobile product={product} index={index} />
            )}
          </div>
        ))}

      {products.length > 0 ? (
        products.map((product, index) => {
          return (
            <div
              key={product.id}
              className={
                ' overflow-hidden w-full sm:1/2 md:w-1/3 xl:w-1/4 border-light-gray-300 md:border-l border-b'
              }
            >
              {!isMobile ? (
                <ProductDefault
                  product={product}
                  index={
                    hasPriorityProducts
                      ? priorityProducts.length + index
                      : index
                  }
                />
              ) : (
                <ProductDefaultMobile
                  product={product}
                  index={
                    hasPriorityProducts
                      ? priorityProducts.length + index
                      : index
                  }
                />
              )}
            </div>
          );
        })
      ) : (
        <div className="w-full">
          <p className="text-center block py-5">نتیجه‌ای یافت نشد!</p>
        </div>
      )}
    </div>
  );
}
